module.exports = __webpack_public_path__ + "img/guitar-landing-banner-opt.08bdab2d.png";